
import React, { useState } from "react";
import { QuizResult, ContactInfo } from "@/types";
import ScoreDisplay from "@/components/results/ScoreDisplay";
import StrengthsAndImprovements from "@/components/results/StrengthsAndImprovements";
import ContactForm from "@/components/results/ContactForm";
import ReportSuccess from "@/components/results/ReportSuccess";

interface ResultsSummaryProps {
  result: QuizResult;
  onRestart: () => void;
  onGetReport?: () => void;
}

const ResultsSummary: React.FC<ResultsSummaryProps> = ({ result, onRestart, onGetReport }) => {
  const [contactInfo, setContactInfo] = useState<ContactInfo | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleFormSuccess = (info: ContactInfo) => {
    setContactInfo(info);
    setIsSubmitted(true);
    
    // If onGetReport callback is provided, call it after a short delay to allow UI updates
    if (onGetReport) {
      setTimeout(() => {
        onGetReport();
      }, 500);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="gradient-bg text-white p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Your AI Governance Readiness Results</h2>
        <p className="text-lg max-w-2xl mx-auto">
          Based on your responses, we've assessed your board's AI governance readiness.
        </p>
      </div>

      <div className="p-8">
        <div className="flex flex-col md:flex-row gap-8 mb-10">
          <div className="flex-1">
            <ScoreDisplay result={result} />
          </div>
          
          <div className="flex-1">
            <StrengthsAndImprovements 
              strengths={result.strengths} 
              improvements={result.improvements} 
            />
          </div>
        </div>

        {!isSubmitted ? (
          <ContactForm onSubmitSuccess={handleFormSuccess} />
        ) : contactInfo && (
          <ReportSuccess result={result} contactInfo={contactInfo} />
        )}
        
        <div className="mt-8 text-center">
          <button 
            onClick={onRestart} 
            className="btn-secondary px-6 py-2 rounded-md"
          >
            Take Assessment Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultsSummary;
